import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { fadeInUpInView } from '../lib/motionPresets';

const REVIEWS = [
  {
    name: 'Maggie B.',
    location: 'Google Review',
    quote: 'Amazing experience from beginning to end! All of the chairs, tables, tent, and play area was SO clean and almost looked brand new! So impressed with their service and would recommend them over and over!',
  },
  {
    name: 'Shari P.',
    location: 'Google Review',
    quote: 'Rented tables, chairs, and a tent for a party and my experience was top notch. Mel and her team are very timely and very professional. They did everything they said they would, when they said they would.',
  },
  {
    name: 'Lauren L.',
    location: 'Google Review',
    quote: "I've used this rental company twice now and highly recommend them. Mel was communicative and punctual, and all the equipment was perfect. Looking forward to the next occasion.",
  },
  {
    name: 'Marilyn D.',
    location: 'Google Review',
    quote: 'Great experience with this company! I needed a tent, tables and chairs pretty much last minute, delivered and picked up all on the same day, and they were able to accommodate at a very reasonable rate.',
  },
];

const Stars = () => (
  <div className="flex gap-1 mb-3" aria-label="5 out of 5 stars">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={18} className="text-yellow-400" fill="#FACC15" />
    ))}
  </div>
);

const ReviewCard = ({ review, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ delay: index * 0.1 }}
    className="bg-white rounded-3xl p-6 border-2 border-orange-100 shadow-lg hover:shadow-xl transition-shadow relative"
    data-testid={`review-card-${index}`}
  >
    <Quote size={28} className="text-orange-200 absolute top-4 right-4" />
    <Stars />
    <p className="text-gray-700 mb-4">"{review.quote}"</p>
    <p className="font-bold text-violet-700">{review.name}</p>
    <p className="text-sm text-gray-500">{review.location}</p>
  </motion.div>
);

export const HomeReviews = () => (
  <section className="py-16 px-6" style={{ backgroundColor: '#FFF7ED' }} data-testid="reviews-section">
    <div className="max-w-7xl mx-auto">
      <motion.div {...fadeInUpInView} className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold heading-font mb-3" style={{ color: '#7C3AED' }}>
          What Our Customers Say
        </h2>
        <div className="flex items-center justify-center gap-2">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} size={24} className="text-yellow-400" fill="#FACC15" />
            ))}
          </div>
          <span className="text-lg font-bold text-gray-700">4.7 on Google</span>
        </div>
        <p className="text-gray-600 mt-2">4.7 stars · 31 Google reviews · Trusted by families & businesses across Havertown, Delaware & Montgomery County</p>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {REVIEWS.map((review, index) => (
          <ReviewCard key={review.name} review={review} index={index} />
        ))}
      </div>
      <div className="flex flex-wrap justify-center gap-4 mt-10">
        <a
          href="https://g.page/r/CXkp_HIOY8JYEBE"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-white border-2 border-orange-300 text-violet-700 px-8 py-3 rounded-full font-bold shadow hover:shadow-lg hover:border-orange-400 transition-all"
          data-testid="read-google-reviews-button"
        >
          <Star size={18} className="text-yellow-400" fill="#FACC15" /> Read Our Google Reviews
        </a>
        <a
          href="https://g.page/r/CXkp_HIOY8JYEBE/review"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white px-8 py-3 rounded-full font-bold shadow hover:shadow-lg hover:scale-105 transition-all"
          data-testid="leave-google-review-button"
        >
          Leave Us a Review
        </a>
      </div>
    </div>
  </section>
);

export default HomeReviews;
